import React, { FC } from 'react';
import { useDrawerNavigation } from '@minecraft.drawer';
import { gqlProfileSearchInput } from '@minecraft.graphql-types';
import { FilterDrawerType, FiltersCategoryNameEnum } from '../../shared/types';
import {
  AssetsCategory,
  ClothingSizesCategory,
  DocumentsCategory,
  EyeColorCategory,
  FacialHairCategory,
  HairColorCategory,
  HairLengthStyleCategory,
  HeightAndWeightCategory,
  MultipleBirthCategory,
  OtherExperienceCategory,
  NewTalentCategory,
  PregnancyDueDateCategory,
  ProfessionCategory,
  RolePreferencesCategory,
  SkillsCategory,
  TattoosAndPiercingsCategory,
  UniqueAttributesCategory,
  VehicleCategory,
  WorkPermitExpirationDatesCategory,
} from '../../FilterDrawerCategories';

interface Props {
  refetchProfileFilterData?: ({ input: object, resultType: string }) => void;
  appliedQueryInput?: gqlProfileSearchInput;
  type: FilterDrawerType;
  accountCountryCode: string;
}

const AdditionalFiltersSection: FC<Props> = ({
  type,
  accountCountryCode,
  refetchProfileFilterData,
  appliedQueryInput,
}) => {
  const { shouldCategoryBeVisible } = useDrawerNavigation();

  const isReps = type === FilterDrawerType.Reps;
  const isCasting = type === FilterDrawerType.Casting;
  const isTalentScout = type === FilterDrawerType.TalentScout;

  return (
    <>
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.assets) && <AssetsCategory type={type} />}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.clothingSizes) && (
        <ClothingSizesCategory type={type} accountCountryCode={accountCountryCode} />
      )}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.documents) && <DocumentsCategory type={type} />}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.eyeColor) && <EyeColorCategory type={type} />}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.facialHair) && <FacialHairCategory type={type} />}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.hairColor) && <HairColorCategory type={type} />}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.hairLengthStyle) && <HairLengthStyleCategory type={type} />}
      {(isReps || isTalentScout) && shouldCategoryBeVisible(FiltersCategoryNameEnum.heightAndWeight) && (
        <HeightAndWeightCategory type={type} />
      )}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.multipleBirth) && <MultipleBirthCategory type={type} />}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.otherExperience) && <OtherExperienceCategory type={type} />}
      {isCasting && shouldCategoryBeVisible(FiltersCategoryNameEnum.newTalent) && <NewTalentCategory type={type} />}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.pregnancyDueDate) && <PregnancyDueDateCategory type={type} />}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.profession) && <ProfessionCategory type={type} />}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.rolePreferences) && <RolePreferencesCategory type={type} />}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.skills) && (
        <SkillsCategory
          appliedQueryInput={appliedQueryInput}
          refetchProfileFilterData={refetchProfileFilterData}
          type={type}
        />
      )}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.tattoosAndPiercings) && (
        <TattoosAndPiercingsCategory type={type} />
      )}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.uniqueAttributes) && <UniqueAttributesCategory type={type} />}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.vehicle) && <VehicleCategory type={type} />}
      {(isReps || isTalentScout) && shouldCategoryBeVisible(FiltersCategoryNameEnum.workPermitExpirationDates) && (
        <WorkPermitExpirationDatesCategory type={type} />
      )}
    </>
  );
};

export default AdditionalFiltersSection;
